export enum LocalStorageKeys {
  LastMeetingModalShown = 'lastMeetingModalShown'
}